import script from "./ShareTableDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareTableDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ShareTableDialog.vue?vue&type=style&index=0&id=50f48adb&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f48adb"]])

export default __exports__